import { NativeModules } from 'react-native';
/**
 * Signed out: the phone forgets which calls its rings were. On an iPhone the
 * numbers in Recents stop leading back to this account's calls
 * (VRSRecentsPhoneHandlesKey); on Android the caller the ring screen last
 * answered is dropped (VRSRingStop.forgetAnsweredCall). A build without the
 * method has nothing to forget.
 *
 * @returns {Promise<unknown>}
 */
export function forgetCallHandles() {
    const module = NativeModules?.VRSNotifications;
    return module?.forgetCallHandles ? module.forgetCallHandles() : Promise.resolve(false);
}
